import React from 'react';
import { Shield, Truck, Clock, Award } from 'lucide-react';

const trustBadges = [
  {
    icon: Shield,
    title: "Paiement sécurisé",
    description: "CB, virement, espèces"
  },
  {
    icon: Truck,
    title: "Livraison possible",
    description: "Haute & Basse-Normandie"
  },
  {
    icon: Clock,
    title: "Disponible 7J/7",
    description: "Sur rendez-vous"
  },
  {
    icon: Award,
    title: "Matériel pro",
    description: "Formations et conseils"
  }
];

const TrustBadges = () => {
  return (
    <section className="py-8 bg-slate-900 border-y border-slate-800">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {trustBadges.map((badge, index) => (
            <div 
              key={index}
              className="flex flex-col items-center text-center group"
            >
              <div className="w-14 h-14 md:w-20 md:h-20 mb-3 md:mb-4 bg-green-500/20 rounded-xl md:rounded-2xl flex items-center justify-center group-hover:bg-green-500/30 transition-colors">
                <badge.icon className="text-green-400" size={28} />
              </div>
              <div className="text-white font-semibold text-sm md:text-base">{badge.title}</div>
              <div className="text-slate-400 text-xs md:text-sm">{badge.description}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustBadges;
